import React from 'react'

export default function Interest() {
  return (
    <section className="resume-section" id="interests">
          <div className="resume-section-content">
            <h2 className="mb-5">Interests</h2>
            <p>Apart from being a web developer, I enjoy most of my time being outdoors.</p>
            <p className="mb-0">When forced indoors, I follow a number of sci-fi and fantasy genre movies and television shows, I spend a large amount of my free time exploring the latest technology advancements in the front-end web development world.</p>
          </div>
        </section>
  )
}
